import React from 'react';
import ContentLoader from 'react-content-loader';
import useIsMobile from './useIsMobile';
import CustomCircularProgress from './CircularProgressLoader';

const ChatSkeleton: React.FC = () => {
  const isMobile = useIsMobile();
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const width = isMobile ? windowWidth : windowWidth * 0.6;
  const height = isMobile ? windowHeight : windowHeight * 0.9;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
      <ContentLoader
        speed={2}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        backgroundColor="#e8e8e8"
        foregroundColor="#828282"
        preserveAspectRatio="none"
      >
        {/* Profile Avatar */}
        <circle cx={isMobile ? "32": "56"} cy={isMobile ? "32": "56"} r={isMobile ? "16": "32"} />

        {/* Recruiter Name */}
        <rect x={isMobile ? "60": "100"} y={isMobile ? "20": "34"} rx="5" ry="5" width={isMobile ? "120": "200"} height={isMobile ? "8": "12"} />
        <rect x={isMobile ? "60": "100"} y={isMobile ? "36": "64"} rx="5" ry="5" width={isMobile ? "150": "250"} height={isMobile ? "8": "12"} />

        {/* Input Text Field */}
        <rect x='32' y={height - (isMobile ? 42: 60)} rx="5" ry="5" width={width - width/2} height={isMobile ? "8": "12"} />
      </ContentLoader>

      {/* CircularProgress on top center */}
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', }}>
        <CustomCircularProgress />
      </div>

        {/* CircularProgress on top center */}
        <div className="border-Gray5 rounded-md" style={{ position: 'absolute', top: height - (isMobile ? 64 : 88), left: isMobile ? 16 : 24, width: width - (isMobile ? 32 : 48), height: isMobile ? 48 : 64 }}></div>
    </div>
  );
};

export default ChatSkeleton;
